import { createAction, props } from '@ngrx/store';

import { Package } from '../../models/package.class';

export enum PackageActionTypes {
    GET_PACKAGES = '[Packages] Get All Packages',
    SET_PACKAGES = '[Packages] Set All Packages',
    CREATE_PACKAGE = '[Packages] Create',
    CREATE_PACKAGE_SUCCESS = '[Packages] Create Success',
    LOAD_ALL_PACKAGES_SUCCESS = '[Packages] Load All Success',
    LOAD_PACKAGE = '[Packages] Load One',
    LOAD_PACKAGE_SUCCESS = '[Packages] Load One Success',
    UPDATE_PACKAGE = '[Packages] Update',
    UPDATE_PACKAGE_SUCCESS = '[Packages] Update Success',
    DELETE_PACKAGE = '[Packages] Delete',
    DELETE_PACKAGE_SUCCESS = '[Packages] Delete Success',
    SET_PACKAGES_SEARCH_TEXT = '[Packages] Set Search Text',
    RESET_PACKAGES_SEARCH_TEXT = '[Packages] Reset Search Text',
}
export const GetPackages = createAction(PackageActionTypes.GET_PACKAGES);

export const SetPackages = createAction(
    PackageActionTypes.SET_PACKAGES,
    props<{
        organizationId: string;
        packages: Package[];
    }>()
);

export const SetPackagesSearchText = createAction(
    PackageActionTypes.SET_PACKAGES_SEARCH_TEXT,
    props<{
        searchText: string;
    }>()
);

export const ResetPackagesSearchText = createAction(PackageActionTypes.RESET_PACKAGES_SEARCH_TEXT);

export const CreatePackage = createAction(PackageActionTypes.CREATE_PACKAGE, props<{ organizationId: string; packageData: any }>());

export const CreatePackageSuccess = createAction(
    PackageActionTypes.CREATE_PACKAGE_SUCCESS,
    props<{ organizationId: string; packageData: any }>()
);

export const LoadAllPackagesSuccess = createAction(
    PackageActionTypes.LOAD_ALL_PACKAGES_SUCCESS,
    props<{ organizationId: string; packages: Package[] }>()
);

export const SelectPackage = createAction(PackageActionTypes.LOAD_PACKAGE, props<{ organizationId: string; packageId: string }>());

export const LoadPackageSuccess = createAction(
    PackageActionTypes.LOAD_PACKAGE_SUCCESS,
    props<{ organizationId: string; packageData: Package }>()
);

export const UpdatePackage = createAction(PackageActionTypes.UPDATE_PACKAGE, props<{ organizationId: string; packageData: Package }>());

export const UpdatePackageSuccess = createAction(
    PackageActionTypes.UPDATE_PACKAGE_SUCCESS,
    props<{ organizationId: string; packageData: Package }>()
);

export const DeletePackage = createAction(PackageActionTypes.DELETE_PACKAGE, props<{ packageId: string }>());

export const DeletePackageSuccess = createAction(
    PackageActionTypes.DELETE_PACKAGE_SUCCESS,
    props<{ organizationId: string; packageId: string }>()
);
